import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import {
  CandidateBuilder,
  GetInternalCandidatesInput,
  GetInternalCandidatesOutput,
} from '../candidates.types';

export const getInternalCandidates = (builder: CandidateBuilder) =>
  builder.query<GetInternalCandidatesOutput, GetInternalCandidatesInput>({
    query: (args) => {
      const baseParams = {
        take: args.query?.take ?? 10,
        page: args.query?.page ?? 1,
        ...args.query,
      };

      const tenantIds = args.query?.TenantIds;

      if (tenantIds) {
        delete baseParams.TenantIds;
      }

      const tenantParams = tenantIds
        ? Object.fromEntries(tenantIds.map((v, i) => [`TenantIds[${i}]`, v]))
        : {};

      return {
        url: '/candidates',
        method: 'GET',
        params: {
          ...baseParams,
          ...tenantParams,
        },
      };
    },
    transformErrorResponse: (err, meta, args) => {
      errorHandler(
        '[getInternalCandidates]',
        (args.lang ?? 'en') === 'en'
          ? ErrorMessageEn.ErrorGettingInternalCandidates
          : ErrorMessageEs.ErrorGettingInternalCandidates,
        err,
        true
      );

      return err.data;
    },
    providesTags: (result) =>
      result
        ? [
            ...result.data.map(({ Id }) => ({
              type: 'Candidate' as const,
              Id,
            })),
            { type: 'Candidates' },
          ]
        : [{ type: 'Candidates' }],
  });
